import react, { useRef, useState } from "react";
import WebDevelopment3 from "../../new_Images/OtherComponents/19.png";

import WebDevelopment5 from "../images/development.png";

import bigdata from "../../new_Images/OtherComponents/Application Mordanization.png";

import webdevdesign from "../images/web-development-web-design-.png";

import applicationmanagement from "../images/webThree.png";

import approach from "../images/approach-.png";

import Topimg1 from "../images/SpringBootN.png";

import Topimg2 from "../images/ReactN.jpg";

import Topimg3 from "../images/Node.png";

import Topimg4 from "../images/javaN.jpg";

import Topimg5 from "../images/Topimg5.png";

import Topimg6 from "../images/JavaScriptimg.png";

import Topimg7 from "../images/Topimg7.png";

import TopBootstrap from "../images/Addimg6.png";

import WebVideo from "../../videos/Webdevelopment.gif";

import WebimageN from "../../videos/WEBIMAGE.png";

import "../../App.css";

import { IoShieldCheckmarkSharp } from "react-icons/io5";

import { Helmet } from "react-helmet";

import PricePlans from "./Price";
import FAQ from "./FAQ";

function WebDevelopment() {
  // video gif -----------

  const mediaRef = useRef();

  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      <Helmet>
        <title>Web Development Services | CLOTA Technology</title>
        <meta
          name="description"
          content="Clota offers scalable, modern web development solutions tailored to your business needs — from design to deployment and ongoing management."
        />
        <meta
          name="keywords"
          content="Web Development, Application Modernization, Web Design, Responsive Websites, Custom Applications, Clota, Full Stack Development, Java, React, Node"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Clota Technology" />
        <link rel="canonical" href="https://www.clotatech.com/WebDevelopment" />
      </Helmet>

      {/* <div className="">
        <img
          src={WebDevelopment3}
          className="w-full homebanner"
          alt="Responsive"
        />
      </div> */}
      <div className="banner-container">
        <img src={WebDevelopment3} className="banner-image" alt="Banner" />

        {/* Centered Content */}
        <div className="banner-content">
          <div className="banner-text">
            <h1 className="banner-heading">Web Development</h1>
            <p>
              Engage with professionals who craft custom
              <br />
              websites and web applications.
            </p>
          </div>
        </div>
      </div>

      <div className="md:pl-6 md:pr-6 webcont1 mt-5 px-5 py-2">
        <div className="grid">
          <div
            className="col-12 md:col-6 webcon1N"
            style={{ marginTop: "2rem" }}>
            <h3
              style={{ fontFamily: "rockwell", fontSize: "1.3rem" }}
              className="Text-Gradient">
              <b>
                <i>Our Development Process</i>
              </b>
            </h3>

            {/* <div

        style={{ fontFamily: "rockwell" }}
      >
        <h3 className="Text-Gradient">
          <b>                 <i>Our Development Process</i></b>
        </h3>
      </div> */}

            <div className="homepara">
              <p>
                <i>
                  Clota Technology craft websites as powerful business channels,
                  engaging audiences with elegant design and unique concepts,
                  precisely tailored to specific needs.
                </i>
              </p>
            </div>

            <br />
          </div>

          <div className="col-12 md:col-6 WebconN2">
            <div className="feature text-center webvideoplay">
              <p className="text-center" style={{ fontWeight: "500" }}>
                Hover To Play
              </p>

              <img
                ref={mediaRef}
                title="hover to play"
                src={isHovered ? WebVideo : WebimageN}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                alt="MyImage"
                className="img-fluid mb-3 border-round"
                style={{ height: "50vh", width: "100%" }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* We Shape your web project */}

      <div className="mt-5 px-5 py-2">
        <div className="row justify-content-start">
          {/* <h3 style={{ fontFamily: "rockwell" }} className="mb-4 Text-Gradient">
            <b>Clota Technology Shape Your Web Project</b>
          </h3> */}
          <div
            className="mb-4 Text-Gradient"
            style={{ fontFamily: "rockwell" }}>
            <h3>
              <b>Clota Technology Shape Your Web Project</b>
            </h3>
          </div>

          <div className="">
            <strong
              className="Text-Gradient"
              style={{ fontFamily: "rockwell" }}>
              <IoShieldCheckmarkSharp className="missionVisionBanner-icon" />

              <b>
                <i>Custom Application Development : </i>
              </b>
            </strong>

            <span>
              <i>
                Clota Technology generate standout online design ideas through
                thorough research on industry trends, competition, and target
                consumers.
              </i>
            </span>

            <div>
              <strong
                className="Text-Gradient"
                style={{ fontFamily: "rockwell" }}>
                <IoShieldCheckmarkSharp className="missionVisionBanner-icon" />

                <b>
                  <i>Application Modernization : </i>
                </b>
              </strong>

              <span>
                <i>
                  Clota Technology turn ideas into seamless online solutions,
                  integrating web services or APIs without compromising
                  performance or user experience.
                </i>
              </span>
            </div>

            <div>
              <strong
                className="Text-Gradient"
                style={{ fontFamily: "rockwell" }}>
                <IoShieldCheckmarkSharp className="missionVisionBanner-icon" />

                <b>
                  <i>Application Management Services : </i>
                </b>
              </strong>

              <i>
                Clota Technology provide enterprise-grade infrastructure and
                24/7 support to enhance, upgrade, and maintain your website
                continuously.
              </i>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Application Development */}

      <div className="mt-5 px-5 py-2 grid">
        <div className="col-12 md:col-6 flex justify-content-center">
          <img
            src={WebDevelopment5}
            alt="responsiveImage"
            className="w-7 h-15rem"
          />
        </div>

        <div className="col-12 md:col-6">
          {/* <h3
            className="mt-5 mb-4 Text-Gradient"
            style={{ fontFamily: "rockwell" }}
          >
            <b>Custom Application Development</b>
          </h3> */}
          <div
            className="mt-5 mb-4 Text-Gradient"
            style={{ fontFamily: "rockwell" }}>
            <h3 className="">
              <b>Custom Application Development</b>
            </h3>
          </div>
          <p>
            <i>
              Clota Technology develop secure and effective applications
              tailored to diverse needs using various frameworks and databases.
              Clota Technology experienced full-time developers cater to
              startups and established enterprises, delivering precision beyond
              off-the-shelf products.
            </i>
          </p>
        </div>
      </div>

      <br />

      {/* Top Frameworks We Use: */}

      <div className="px-5 py-2 text-center">
        <div
          className="mt-5 px-5 py-2 text-center Text-Gradient"
          style={{ fontFamily: "rockwell" }}>
          <h1 className="mb-4">
            <b>Top Frameworks We Use:</b>
          </h1>
        </div>
        <div className="grid">
          {[
            Topimg1,
            Topimg4,
            Topimg2,
            Topimg7,
            Topimg6,
            Topimg3,
            TopBootstrap,
            Topimg5,
          ].map((img, index) => (
            <div key={index} className="col-6 md:col-3 mb-4">
              <div
                className="border-round overflow-hidden"
                style={{ height: "150px" }}>
                <img src={img} alt="framework" className="w-full h-full" />
              </div>
            </div>
          ))}
        </div>
      </div>

      <br />

      <div className="mt-5 px-5 py-2 grid">
        <div className="col-12 md:col-6">
          <h3
            className="Text-Gradient"
            style={{ fontFamily: "rockwell", fontSize: "1.3rem" }}>
            <b>
              <i>Application Modernization</i>
            </b>
          </h3>
          <p>
            <i>
              CLOTA designs secure, scalable web apps and offers turnkey
              solutions for business app modernization, simplifying Java-based
              projects with efficient frameworks.
            </i>
          </p>
        </div>
        <div className="col-12 md:col-6 flex justify-content-center align-items-center">
          <img src={bigdata} alt="responsiveImage" className="w-11 md:w-8" />
        </div>
      </div>

      <div className="mt-5 px-5 py-2 grid">
        <div className="col-12 md:col-6 flex flex-column align-items-center justify-content-center mt-4">
          <img
            src={webdevdesign}
            alt="responsiveImage"
            className="w-8 h-20rem"
          />
        </div>
        <div className="col-12 md:col-6">
          <h4
            className="mt-4 mb-4 Text-Gradient"
            style={{ fontFamily: "rockwell", fontSize: "1.3rem" }}>
            <b>
              <i>Web Design That is Device friendly</i>
            </b>
          </h4>
          <p>
            <i>
              Clota Technology make apps accessible across platforms with
              responsive design, improving conversion rates across screens with
              one solution.
            </i>
          </p>
        </div>
      </div>

      <div className="mt-5 px-5 py-2 grid">
        <div className="col-12 md:col-6">
          <h4
            className="Text-Gradient"
            style={{ fontFamily: "rockwell", fontSize: "1.3rem" }}>
            <b>
              <i>Application Management Services</i>
            </b>
          </h4>
          <p>
            <i>
              CLOTA's security and maintenance services keep your web properties
              fast and secure, while our application management services reduce
              IT costs for businesses.
            </i>
          </p>
        </div>
        <div className="col-12 md:col-6 flex justify-content-center align-items-center">
          <img
            src={applicationmanagement}
            alt="responsiveImage"
            className="w-10 border-round"
          />
        </div>
      </div>
      {/* Our Approach */}

      <div className="mt-5 px-5 py-2 grid">
        <div className="col-12 md:col-6">
          <h1
            className="Text-Gradient"
            style={{ fontFamily: "rockwell", fontSize: "1.3rem" }}>
            <b>Our Approach</b>
          </h1>
          <ul className="list-none pl-0">
            {[
              "Analyze and evaluate current systems.",
              "Application Maintenance.",
              "Learn about new business requirements and expectations.",
              "Architect and design the portfolio, Create, Test and Deploy.",
              "Continuously supporting, monitoring and improving performance.",
              "Boosted business productivity.",
              "Connect to other applications.",
              "Improved IT and application system quality and reliability.",
              "Learning about new business requirements and expectations.",
              "Reduce the risks associated with people and legacy skills.",
              "Application Enhancements & Integration.",
              "Eliminate flaws at every construction stage.",
              "Ship tested solutions to prevent business losses during production.",
            ].map((item, index) => (
              <li key={index} className="mb-2">
                <IoShieldCheckmarkSharp className="missionVisionBanner-icon" />
                <i>{item}</i>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-12 md:col-6 flex flex-column align-items-center justify-content-center">
          <img src={approach} alt="responsiveImage" className="w-10 " />
        </div>
      </div>
      <PricePlans />

      <div>
        <FAQ />
      </div>
    </>
  );
}

export default WebDevelopment;
